import sublimationPrinting from "./templates/sublimation-printing";

export default [
  {
    id: `material`,
    title: `Крой и качество материала`,
    content: {
      description: `
        <p>Подушка 150x50см с рисунком или фотографией на всей поверхности.</p>
        <p>Подушки сшиты из мокрого шёлка - это ткань премиального качества. По сравнению с атласом или сатеном, мокрый шёлк очень нежный и приятный. На подушках из мокрого шёлка можно смело спать.</p>
        <p>Наполнитель: экологически чистый синтепон.</p>
        <p>Размеры и область печати: 150x50см.</p>
      `
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${sublimationPrinting}`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
